export const processHeadersMiddleware = callback => response => {
  callback(response.headers);
  return response;
};
